<!--
 * @Author: whitechiina 1293616053@qq.com
 * @Date: 2026-01-26 15:48:23
 * @LastEditors: whitechiina 1293616053@qq.com
 * @LastEditTime: 2026-01-26 16:42:41
 * @FilePath: /传媒后台管理系统/src/views/Login.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="login-container">
    <el-card class="login-card">
      <h2 class="login-title">传媒后台管理系统</h2>
      <el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-width="80px">
        <el-form-item label="账号" prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="loginForm.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('loginForm')" style="width: 100%">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/chuanmei/auth/login', this.loginForm)
            .then(response => {
              if (response.data.success) {
                localStorage.setItem('isAuthenticated', 'true')
                this.$message.success('登录成功')
                this.$router.push('/home/carousel')
              } else {
                this.$message.error(response.data.message || '登录失败')
              }
            })
            .catch(error => {
              console.error('登录请求失败:', error)
              this.$message.error('登录请求失败，请稍后重试')
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f7fa;
}

.login-card {
  width: 400px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.login-title {
  text-align: center;
  margin-bottom: 30px;
  color: #303133;
}
</style>


// WEBPACK FOOTER //
// src/views/Login.vue